import { render, staticRenderFns } from "./main-tile.vue?vue&type=template&id=49d3acf0&scoped=true&"
import script from "./main-tile.vue?vue&type=script&lang=js&"
export * from "./main-tile.vue?vue&type=script&lang=js&"
import style0 from "./main-tile.vue?vue&type=style&index=0&id=49d3acf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3acf0",
  null
  
)

export default component.exports